import AxiosConfig from "./AxiosConfig";
import Routing from "./routing";

const login = async (values) => {
    try {
        if (process.env.REACT_APP_MODE === 'maquette') {
            const utilisateursData = JSON.parse(localStorage.getItem('utilisateursData'));
            const utilisateur = utilisateursData.find(user => user.email === values.email);

            if (utilisateur) {
                localStorage.setItem('currentUser', JSON.stringify(utilisateur));
                return utilisateur;
            } else {
                throw new Error("Identifiants incorrects en mode maquette");
            }
        } else {
            if (!values.email || !values.password || !values.captchaToken) {
                console.error('Missing fields:', values);
                return false;
            }

            const response = await AxiosConfig.post(Routing.routesApi.login_check, {
                username: values.email,
                password: values.password,
                captchaToken: values.captchaToken
            });
            if (response.data.token) {
                localStorage.setItem('jwt_token', response.data.token);
                localStorage.setItem('refresh_token', response.data.refresh_token);
                return { success: true, message: 'Connexion réussie' };
            }
            return response.data;
        }
    } catch (error) {
        console.error('Erreur lors de la tentative de connexion:', error.message);
        throw error;
    }
};

const getUser = async () => {
    const user = await AxiosConfig.get(Routing.routesApi.user);
    return user.data;
}

const resetPassword = async (values) => {
    if (!values.email || !values.captchaToken) {
        console.error('Missing fields:', values);
        return false;
    }

    const response = await AxiosConfig.post(Routing.routesApi.passwordReset, {
        email: values.email,
        captchaToken: values.captchaToken
    });
    return response.data;
};

const setNewPassword = async (values, token, mail) => {
    const url = Routing.generate({route: Routing.routesApi.passwordNew, params: {token, mail}});
    const response = await AxiosConfig.post(url, {
        password: values.password,
    });
    return response.data;
};

const logout = () => {
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('currentUser');
    sessionStorage.clear();
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.trim().replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/');
    });
    window.location.reload();
}

export { login, resetPassword, setNewPassword, logout, getUser };
